import axios from 'api/axios'
import { BroadcastContact } from 'types'

export interface GetBroadCastContactsOptions {
	id: string
	page: number
	size: number
	process?: boolean
	query?: string
}

export interface GetBroadcastContactsResponse {
	totalCount: number
	records: BroadcastContact[]
	totalPages: number
	currentPage: number
}

const getBroadcastContacts = async (
	options: GetBroadCastContactsOptions
): Promise<GetBroadcastContactsResponse> => {
	const { id, ...params } = options
	const { process } = options
	if (params.process !== undefined) {
		delete params.process
	}
	const { data } = await axios.get<GetBroadcastContactsResponse>(
		`v1/broadcast/management/contacts/${id}`,
		{
			params: {
				...params,
				...(typeof process === 'boolean'
					? { status: process ? 'PROCESSED' : 'IN_PROCESS' }
					: {}),
			},
		}
	)

	// This is to prevent broken data from messing with rendering the table
	const contacts = data.records.filter(record => record.contact !== null)

	return { ...data, records: contacts }
}

export default getBroadcastContacts
